import { useEffect, useState, useRef } from 'react';

export const useDropdownKeyboardNavigation = ({
    items = [],
    state = false,
    onItemSelect,
    onItemControlEnterSelect,
    onItemAltCSelect,
    onItemAltDSelect,
    onItemAltASelect,
    onItemSpaceSelect,
    onItemAlt2Select,
    onItemAltISelect,
    onItemAltRSelect,
    onItemAltUSelect,
    onItemF1Select,
    onItemF2Select,
    onItemF3Select,
    onItemF4Select,
    onItemF5Select,
    onItemF6Select,
    onItemF7Select,
    onItemF8Select,
    onItemF9Select,
    onItemF10Select,
    onItemF11Select,
    onItemF12Select,
    onItemAltF1Select,
    onItemAltF7Select,
    onItemCtrlASelect,
    input_value = '',
    inputRef,
    getLabel,
    initialIndex = 0,
    enableAlphaJump = false,
    containerRef,
}) => {
    const [selectedItemIndex, setSelectedItemIndex] = useState(initialIndex);
    const lastSyncedValueRef = useRef(input_value);
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (document.querySelector('.modal_link') || document.querySelector('.modal_message')) {
                return;
            }
            if (state) {
                // Check if the input associated with this dropdown is currently focused
                if (inputRef && inputRef.current && document.activeElement !== inputRef.current) {
                    return;
                }

                if (e?.key === 'ArrowUp') {
                    e?.preventDefault();
                    setSelectedItemIndex((prev) => Math?.max(prev - 1, 0));
                } else if (e?.key === 'ArrowDown') {
                    e?.preventDefault();
                    setSelectedItemIndex((prev) => Math?.min(prev + 1, items?.length - 1));
                } else if (e?.key === 'Enter' && !e?.ctrlKey) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation(); // Prevent element listeners from firing
                    }
                    if (items && items[selectedItemIndex] && onItemSelect) {
                        onItemSelect(items[selectedItemIndex]);
                    }
                } else if (e?.ctrlKey && e?.key === 'Enter') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemControlEnterSelect) {
                        if (items[selectedItemIndex]?.alterEnabled === 0) {
                            return;
                        }
                        onItemControlEnterSelect(items[selectedItemIndex]);
                    }
                } else if (e?.altKey && (e?.key === 'c' || e?.key === 'C')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAltCSelect) {
                        onItemAltCSelect(items[selectedItemIndex]);
                    } else if (onItemAltCSelect) {
                        onItemAltCSelect();
                    }
                } else if (e?.altKey && (e?.key === 'd' || e?.key === 'D')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAltDSelect) {
                        onItemAltDSelect(items[selectedItemIndex]);
                    }
                } else if (e.altKey && (e.key === 'a' || e.key === 'A')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAltASelect) {
                        onItemAltASelect(items[selectedItemIndex]);
                    }
                } else if (e.key === ' ') {
                    if (state && onItemSpaceSelect) {
                        e?.preventDefault();
                        e?.stopPropagation();
                        if (items && items[selectedItemIndex]) {
                            onItemSpaceSelect(items[selectedItemIndex]);
                        }
                    }
                } else if (e.altKey && e.key === '2') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAlt2Select) {
                        onItemAlt2Select(items[selectedItemIndex]);
                    }
                } else if (e.altKey && (e.key === 'i' || e.key === 'I')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAltISelect) {
                        onItemAltISelect(items[selectedItemIndex]);
                    }
                } else if (e.altKey && (e.key === 'r' || e.key === 'R')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAltRSelect) {
                        onItemAltRSelect(items[selectedItemIndex]);
                    }
                } else if (e.altKey && (e.key === 'u' || e.key === 'U')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (onItemAltUSelect) {
                        onItemAltUSelect(items ? items[selectedItemIndex] : undefined);
                    }
                } else if (e.key === 'F1' && !e.altKey) {
                    if (onItemF1Select) {
                        e.preventDefault();
                        if (state) e.stopPropagation();
                        onItemF1Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F1' && e.altKey) {
                    if (onItemAltF1Select) {
                        e.preventDefault();
                        if (state) e.stopPropagation();
                        onItemAltF1Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F2') {
                    if (onItemF2Select) {
                        e.preventDefault();
                        if (state) e.stopPropagation();
                        onItemF2Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F3') {
                    if (onItemF3Select) {
                        e.preventDefault();
                        if (state) e.stopPropagation();
                        onItemF3Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F4') {
                    if (onItemF4Select) {
                        e.preventDefault();
                        if (state) e.stopPropagation();
                        onItemF4Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F5') {
                    if (onItemF5Select) {
                        e.preventDefault();
                        e.stopPropagation();
                        onItemF5Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F6') {
                    if (onItemF6Select) {
                        e.preventDefault();
                        if (state) e.stopPropagation();
                        onItemF6Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F7' && !e.altKey) {
                    if (onItemF7Select) {
                        e.preventDefault();
                        if (state) e.stopPropagation();
                        onItemF7Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F7' && e.altKey) {
                    if (onItemAltF7Select) {
                        e.preventDefault();
                        if (state) e.stopPropagation();
                        onItemAltF7Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F8') {
                    if (onItemF8Select) {
                        e.preventDefault();
                        if (state) e.stopPropagation();
                        onItemF8Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F9') {
                    if (onItemF9Select) {
                        e.preventDefault();
                        if (state) e.stopPropagation();
                        onItemF9Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F10') {
                    if (onItemF10Select) {
                        e.preventDefault();
                        e.stopPropagation();
                        onItemF10Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F11') {
                    if (onItemF11Select) {
                        e.preventDefault();
                        e.stopPropagation();
                        onItemF11Select(items?.[selectedItemIndex]);
                    }
                } else if (e.key === 'F12') {
                    if (onItemF12Select) {
                        e.preventDefault();
                        if (state) e.stopPropagation();
                        onItemF12Select(items?.[selectedItemIndex]);
                    }
                } else if (e.ctrlKey && (e.key === 'a' || e.key === 'A')) {
                    if (state) {
                        e?.preventDefault();
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex]) {
                        if (onItemCtrlASelect) {
                            onItemCtrlASelect(items[selectedItemIndex]);
                        } else if (onItemSelect) {
                            onItemSelect(items[selectedItemIndex]);
                        }
                    }
                } else if (enableAlphaJump && e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
                    // Alpha Jump logic
                    const char = e.key.toLowerCase();
                    const startIndex = (selectedItemIndex + 1) % items.length;

                    const findNextMatch = (start) => {
                        for (let i = 0; i < items.length; i++) {
                            const index = (start + i) % items.length;
                            const item = items[index];
                            let label = '';
                            if (getLabel) {
                                label = getLabel(item);
                            } else {
                                label = (item?.name || item?.ledger_name || item?.symbol || '');
                            }
                            if (label?.trim()?.toLowerCase()?.startsWith(char)) {
                                return index;
                            }
                        }
                        return -1;
                    };

                    const nextIndex = findNextMatch(startIndex);
                    if (nextIndex !== -1) {
                        e.preventDefault();
                        e.stopPropagation();
                        setSelectedItemIndex(nextIndex);
                    }
                }
            }
        };

        const handleWheel = (e) => {
            if (state) {
                if (inputRef && inputRef.current && document.activeElement !== inputRef.current) {
                    return;
                }
                e?.preventDefault();
                if (e?.deltaY < 0) {
                    setSelectedItemIndex((prev) => Math?.max(prev - 1, 0));
                } else if (e?.deltaY > 0) {
                    setSelectedItemIndex((prev) => Math?.min(prev + 1, items?.length - 1));
                }
            }
        };

        const targetElement = (containerRef && containerRef.current) || window;

        window.addEventListener('keydown', handleKeyDown, true);
        targetElement.addEventListener('wheel', handleWheel, { passive: false });
        return () => {
            window.removeEventListener('keydown', handleKeyDown, true);
            targetElement.removeEventListener('wheel', handleWheel);
        };
    }, [
        items, selectedItemIndex, state, onItemSelect, onItemControlEnterSelect,
        onItemAltCSelect, onItemAltDSelect, onItemAltASelect, onItemSpaceSelect,
        onItemAlt2Select, onItemAltISelect, onItemAltRSelect, onItemAltUSelect,
        onItemF1Select, onItemF2Select, onItemF3Select, onItemF4Select, onItemF5Select,
        onItemF6Select, onItemF7Select, onItemF8Select, onItemF9Select, onItemF10Select,
        onItemF11Select, onItemF12Select, onItemAltF1Select, onItemAltF7Select,
        onItemCtrlASelect, input_value, getLabel, enableAlphaJump, inputRef, containerRef
    ]);

    useEffect(() => {
        if (items?.length > 0 && selectedItemIndex >= items?.length) {
            setSelectedItemIndex(0);
        }
    }, [items?.length, selectedItemIndex]);

    const hasSyncedRef = useRef(false);

    useEffect(() => {
        if (!state) {
            hasSyncedRef.current = false;
            return;
        }

        const isFreshOpen = lastSyncedValueRef.current === null;
        const valueChanged = input_value !== lastSyncedValueRef.current;

        if (isFreshOpen || valueChanged || !hasSyncedRef.current) {
            const index = items?.findIndex((item) => {
                const name = (
                    item?.name ||
                    item?.ledger_name ||
                    item?.voucher_type_name ||
                    item?.symbol ||
                    item?.data?.name ||
                    item?.data?.ledger_name ||
                    ''
                )?.trim()?.toLowerCase();
                const searchValue = (input_value || '')?.trim()?.toLowerCase();
                return name === searchValue;
            });
            if (index !== -1) {
                setSelectedItemIndex(index);
                hasSyncedRef.current = true;
            } else if (isFreshOpen && (!initialIndex || initialIndex === 0)) {
                setSelectedItemIndex(0);
            }
            lastSyncedValueRef.current = input_value;
        }
    }, [state, input_value, items, initialIndex]);

    return { selectedItemIndex, setSelectedItemIndex };
};
